import * as React from 'react';
import { SpateAiIcon } from './spate-ai-icon';
import { cn } from '../../utils/cn';
import { cva } from 'class-variance-authority';

// `strong` and `inverse` reach 4.5:1 on muted panes and dark tooltips.
const aiGeneratedLabelVariants = cva('inline-flex items-center gap-1', {
    variants: {
        tone: {
            default: 'text-muted-foreground',
            strong: 'text-[var(--ai-label-on-muted)]',
            inverse: 'text-[var(--ai-label-on-dark)]',
        },
        // `sm` matches the 11px small print under the assistant input boxes.
        size: { default: 'text-xs', sm: 'text-[11px] leading-4' },
    },
    defaultVariants: { tone: 'default', size: 'default' },
});

/**
 * Marks AI-written text (EU AI Act Art. 50). Place it above or beside the text
 * it labels, never inside it.
 */
const AiGeneratedLabel = React.forwardRef(
    (
        {
            className,
            tone,
            size,
            showIcon = true,
            children = 'AI-generated',
            ...props
        },
        ref,
    ) => (
        <span
            ref={ref}
            className={cn(aiGeneratedLabelVariants({ tone, size }), className)}
            {...props}
        >
            {showIcon && <SpateAiIcon size="1em" />}
            {children}
        </span>
    ),
);
AiGeneratedLabel.displayName = 'AiGeneratedLabel';

export { AiGeneratedLabel };
